// extracted by mini-css-extract-plugin
module.exports = {"iconTitle":"IconTitle_iconTitle__1wwYR","rounded-icon-arrow":"IconTitle_rounded-icon-arrow__1u5bA","title-plus-icon":"IconTitle_title-plus-icon__2tO33"};